import maintainRequest from "@/maintain/utils/maintainRequest";

export default function getGroupList() {
  return maintainRequest({
    url: `/device/maintenanceMan/device_group/getGroupList`,
    method: "post",
  });
}
